export default __webpack_public_path__ + "static/media/Products_Man.db8268dd.png";